import {IPropsApiRequest} from "@helpers/query/types";
import {isTokenExpired, logOut, refreshTokenWidthSave} from "@containers/auth/helpers/helpers";
import {getCookie} from "@helpers/cookie/cookie";
import {defaultBuildFetchOptionsOnRefreshToken} from "@helpers/query/helpers/defaultBuildFetchOptionsOnRefreshToken";
import {refreshTokenAndRefetchResponse} from "@helpers/query/helpers/refreshTokenAndRefetchResponse";
import {buildFetchOptionsWithAuth} from "@helpers/query/helpers/buildFetchOptionsWithAuth";

export const apiRequestWithAuth = async <T>({
                                                url: propsUrl,
                                                options: propsOptions = {},
                                                onError,
                                                buildFetchOptionsCb = defaultBuildFetchOptionsOnRefreshToken,
                                                hasLogOutOnErrorAuth = true
                                            }: IPropsApiRequest): Promise<T> => {
    let token = getCookie('token');
    let refreshToken = getCookie('refreshToken');

    const tokenExpire = isTokenExpired(token);

    if (tokenExpire) {
        if (!refreshToken) {
            if (hasLogOutOnErrorAuth) {
                logOut();
            }
            return
        }
        const res = await refreshTokenWidthSave();
        if (!res) {
            if (hasLogOutOnErrorAuth) {
                logOut();
            }
            return
        }
        token = res.token
        refreshToken = res.refreshToken
    }

    let {
        url,
        options
    } = buildFetchOptionsWithAuth({
        buildFetchOptionsCb,
        options: propsOptions,
        url: propsUrl,
        token,
        refreshToken
    })

    try {
        let resp = await fetch(url, options);

        if (resp.status === 403) {
            const res = await refreshTokenWidthSave();
            if (!res) {
                if (hasLogOutOnErrorAuth) {
                    logOut();
                }
                return
            }
            const newResp = await refreshTokenAndRefetchResponse({
                buildFetchOptionsCb,
                options,
                url,
            })
            if (!newResp) {
                if (hasLogOutOnErrorAuth) {
                    logOut();
                }
                return
            }
            resp = newResp

        }

        if (!resp.ok) {
            const contentType = resp.headers.get("Content-Type") || "";
            if (!contentType.includes('application/json')) {
                return Promise.reject();
            }
            let errors = {};
            try {
                await resp?.json().then((error) => {
                    errors = error;
                    if (onError) {
                        onError(error)
                    }
                });
                return Promise.reject({
                    status: resp.status,
                    ...(errors ?? {}),
                });
            } catch (error) {
                if (onError) {
                    onError(error)
                }
                return Promise.reject({
                    status: resp.status,
                    ...(errors ?? {}),
                });
            }

        }
        const contentType = resp.headers.get("Content-Type") || "";
        if (!contentType.includes('application/json')) {
            return resp.text() as T
        }

        return resp?.json();
    } catch (error) {
        if (onError) {
            onError(error)
        }
        if (error.status === 403) {
            const resp = await refreshTokenAndRefetchResponse({
                buildFetchOptionsCb,
                options,
                url,
            })
            if (!resp) {
                if (hasLogOutOnErrorAuth) {
                    logOut();
                }
                return
            }
            if (!resp) {
                return
            }
            return resp?.json();
        }

        return Promise.reject(error);
    }
};
